import React from 'react';
import { Card } from './styled/Styled';

const KeywordItem = ({item}) => {
    return (
        <Card pv="8" ph="16" mx="8" color="color-white" border="solid" borderColor="color-black" borderWidth="2px" fontSize="15px" fontWeight="600" radius="20px" children={`${item.text}`} />            
    );
};

export default KeywordItem;